/**
 * Reopening a closed bill, and the reason it now requires.
 *
 * Its own module rather than a corner of `cancellations.ts`, because reopening
 * is not a cancellation: it is the operation that puts a settled account back
 * into service, and the control report treats the two as separate blocks with
 * separate catalogs.
 *
 * What it shares with cancelling is the *dialog* — one reason picker serves
 * both, parameterised by path and payload. See `cancel-reason-dialog.tsx`.
 */

import type { CancelPayload } from "@/features/staff/cancellations"

export type ReopenReasonOption = {
  value: string
  label: string
}

export const REOPEN_PATHS = {
  bill: (billId: number) => `/bills/${billId}/reopen`,
} as const

/**
 * The body `Staff::Location::BillsController#reopen` reads.
 *
 * A reason is mandatory server-side: `Location::ReopeningPolicy.label` resolves
 * through `I18n.t!`, which raises rather than falling back, so a reasonless row
 * would take down the control report that renders it. Posting `{}` here is
 * exactly what left the reopen button refusing every request once already.
 */
export function billReopenPayload(reason: string): CancelPayload {
  return { reopen_reason: reason }
}
